import { render, staticRenderFns } from "./NameserverOverview.vue?vue&type=template&id=87b4c8ba&"
import script from "./NameserverOverview.vue?vue&type=script&lang=js&"
export * from "./NameserverOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports